import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import { isMobile } from 'utils/helpers';

const propTypes = {
  nextInvoicingDate: PropTypes.string,
  hasPaidInvoices: PropTypes.bool,
};

const AllPaidInvoiceSection = ({ nextInvoicingDate, hasPaidInvoices }) => (
  <div className="message message--no-invoices message--no-invoices-unpaid">
    <span className="message__icon message__icon--country-fi" />
    <div className="invoices invoices--all-paid">
      <span className="invoices__title">
        <FormattedMessage id={`selfservice.invoices.${!hasPaidInvoices && COUNTRY === 'AU' ? 'nonePaidYet' : 'allPaid'}`} />
      </span>
      <p className={cx({ invoices__text: true, hint: isMobile, 'txt-small': !isMobile })}>
        <FormattedMessage id="selfservice.invoices.paymentDateInfo" />
      </p>
      {((!isMobile || MOBILE_WALLET) && nextInvoicingDate)
        && (
        <p className="invoices__text txt-small">
          <FormattedMessage
            id={`selfservice.invoices.${!hasPaidInvoices && COUNTRY === 'AU' ? 'first' : 'next'}InvoiceDateAvailability`}
            values={{
              formattedDate: moment(nextInvoicingDate).format('L'),
            }}
          />
        </p>
        )}
    </div>
  </div>
);

AllPaidInvoiceSection.propTypes = propTypes;

export default AllPaidInvoiceSection;
